<template>
  <div class="scroll_wrap">
    <div class="en_tit">{{honor.info?.en}}</div>
    <div class="scroll_tit">{{honor.info.title}}</div>
    <div class="card_content pc_container gktp">
      <div class="center-box">
        <swiper ref="honorSwiper" :options="swiperOption">
          <swiper-slide class="box-slide" v-for="(item, index) in honor.list" :key="index">
            <div class="card">
              <img :src="item.cover" lazy />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="czBtn">
        <div class="swiper-button-prev honor-prev" slot="button-prev"> </div>
        <div class="swiper-button-next honor-next" slot="button-next"> </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    honor: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 29,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        navigation: {
          nextEl: '.honor-next',
          prevEl: '.honor-prev'
        }
      }


    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.scroll_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;
  background: #fcfcfc;

  .en_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 48px;
    color: #DCDCDC;
    text-transform: uppercase;
  }

  .scroll_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top: -15px;
    position: relative;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }

    &::after {
      content: '';
      display: block;
      background: #000;
      margin: 0 auto;
      width: 60px;
      height: 5px;
      background: #006DE8;
      margin-top: 13px;
    }
  }

  .gktp {
    margin-top: 30px;
    .center-box {
      height: 292px;
      width: 100%;
      position: relative;
      .card {
        height: 292px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .czBtn {
      width: 120px;
      height: 45px;
      margin: 0 auto;
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .swiper-button-next,
      .swiper-button-prev {
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, .6);
        color:#fff;
        width: 44.5px;
        height: 44.5px;
        z-index: 9;
      }
      .swiper-button-next:after, .swiper-button-prev:after {
        font-size: 20px;
      }
      .swiper-button-next:hover, .swiper-button-prev:hover {
        background: #2A59AB;
      }
    }
  }
}
</style>